import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "customerSummary",
    "siteSummary",
    "serviceSummary",
    "timingSummary",
    "missingSummary",
    "section"
  ]

  connect() {
    this.refresh()
  }

  refresh() {
    this.updateSummary("customerSummary", this.selectedText("guided_job[customer_id]"), "Selected in the form")
    this.updateSummary("siteSummary", this.selectedText("guided_job[customer_asset_id]"), "Selected in the form")
    this.updateSummary("serviceSummary", this.selectedText("guided_job[service_type]"), "Selected in the form")
    this.updateTimingSummary()
    this.updateSections()
    this.updateMissingSummary()
  }

  updateSummary(targetName, value, fallback) {
    const target = this[`${targetName}Target`]
    if (!target) return

    target.textContent = value || fallback
  }

  updateTimingSummary() {
    if (!this.hasTimingSummaryTarget) return

    const date = this.fieldValue("guided_job[scheduled_date]")
    const time = this.fieldValue("guided_job[start_time]")
    const duration = this.fieldValue("guided_job[duration_minutes]")
    const parts = [date, time].filter(Boolean).join(" ")

    this.timingSummaryTarget.textContent = parts
      ? `${parts}${duration ? ` for ${duration} min` : ""}`
      : "Start date and time pending"
  }

  updateSections() {
    this.sectionTargets.forEach((section) => {
      const complete = this.requiredFieldsFor(section).every((name) => this.fieldValue(name))
      section.classList.toggle("is-complete", complete)
      section.classList.toggle("is-missing", !complete)
    })
  }

  updateMissingSummary() {
    if (!this.hasMissingSummaryTarget) return

    const missing = this.sectionTargets
      .filter((section) => !this.requiredFieldsFor(section).every((name) => this.fieldValue(name)))
      .map((section) => section.querySelector("h2")?.textContent?.trim())
      .filter(Boolean)

    this.missingSummaryTarget.textContent = missing.length
      ? `Missing: ${missing.join(", ")}`
      : "Ready to create the job."
  }

  requiredFieldsFor(section) {
    return (section.dataset.requiredFields || "").split(/\s+/).filter(Boolean)
  }

  selectedText(name) {
    const field = this.element.querySelector(`[name='${CSS.escape(name)}']`)
    if (!field) return ""

    const selected = field.options?.[field.selectedIndex]
    return selected && selected.value ? selected.textContent.trim() : ""
  }

  fieldValue(name) {
    const field = this.element.querySelector(`[name='${CSS.escape(name)}']`)
    return field?.value?.trim() || ""
  }
}
